export default "__VITE_ASSET__9GoekJjB__"